import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormControl, InputAdornment, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';
import { wsGetAll } from 'services/WService';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';

const COLUMNAS_EXCEL = ['MESA', 'CLIENTE', 'MUEBLE'];

const limpio = (v) => (v === null || v === undefined ? '' : String(v).trim());

export default WithApp(function ModalCustomerFurniture(props) {
  const control = props.model;
  const esNuevo = !control?.id;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(control);
  const [bureaus, setBureaus] = useState([]);
  const [furnitures, setFurnitures] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [items, setItems] = useState([]);
  const [openModalBPartner, setOpenModalBPartner] = useState(false);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listBureaus() {
    let response = await wsGetAll('base/bureau');

    if (response.success) {
      const bureaus = response.data.filter((bureau) =>
        bureau.description?.toLowerCase().includes('arcor')
      );

      setBureaus(bureaus);
    }
  }

  async function listFurnitures() {
    let response = await wsFindBy('base/furniture',{state: 'F'});
    if (response.success) setFurnitures(response.data);
  }

  async function listAddresses(businessPartnerId) {
    let response = await wsFindBy('base/address', {
      base_business_partner_id: businessPartnerId
    });

    if (response.success) {
      const addresses = response.data.filter(
        (address) => address.AdresType === 'S' && address.state === 'A' && address.deleted_at === null
      );

      setAddresses(addresses);
      handleChange('base_address_id', String(addresses[0]?.id || ''));
    }
  }

  useEffect(() => {
    if (control.open) {
      listBureaus();
      listFurnitures();
      setDataChanging(control);
    }
  }, [control.open]);

  useEffect(() => {
    if (control.open) {
      setBPartnerSelect(undefined);
      setAddresses([]);
      setDataImport({});
      setItems([]);
    }
  }, [control.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setItems(
        dataImport.data.map((item) => ({
          bureau_code: limpio(item['MESA']),
          CardCode: limpio(item['CLIENTE']),
          furniture_serial: limpio(item['MUEBLE'])
        }))
      );
    } else if (dataImport?.success === false) {
      setItems([]);
    }
  }, [dataImport]);

  useEffect(() => {
    if (furnitures.length > 0 && control?.base_furniture_id) {
      handleChange('base_furniture_id', String(control.base_furniture_id));
    }
  }, [furnitures, control]);

  useEffect(() => {
    if (bPartnerSelect?.base_business_partner_id) {
      listAddresses(bPartnerSelect.base_business_partner_id);
    }
  }, [bPartnerSelect]);

  const handleAutocompleteChange = (field, value) => {
    handleChange(field, value?.id || null);

    if (field === 'base_bureau_id') {
      setBPartnerSelect(undefined);
      setAddresses([]);
      setDataImport(null);
    }
  };

  const etiquetaMueble = (item) => `${item.code ? item.code + ' - ' : ''}${item.description}`;

  const importado = dataImport?.success === true;

  const bureauSelect =
    bureaus.find((bureau) => String(bureau.id) === String(dataChanging.base_bureau_id)) || null;
  const furnitureSelect =
    furnitures.find(
      (furniture) => String(furniture.id) === String(dataChanging.base_furniture_id)
    ) || null;

  return (
    <>
      {openModalBPartner ? (
        <ModalFilterBPartner
          open={openModalBPartner}
          setOpen={setOpenModalBPartner}
          cardType="C"
          entity="base/customer-furniture/customers"
          filterProps={{ base_bureau_id: bureauSelect?.id }}
          setBPartnerSelect={setBPartnerSelect}
          extraFields={[{ Header: 'Dirección', accessor: 'Address2' }]}
        />
      ) : undefined}

      <Modal
        title="Control de mueble"
        model={control}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity={importado ? 'base/customer-furniture/multiple' : 'base/customer-furniture'}
        dataForce={
          importado
            ? { items }
            : esNuevo
            ? {
                base_business_partner_id: bPartnerSelect?.base_business_partner_id,
                base_address_id: dataChanging.base_address_id,
                base_furniture_id: furnitureSelect?.id
              }
            : { base_furniture_id: furnitureSelect?.id }
        }
      >
        {esNuevo ? (
          <span style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Autocomplete
              options={bureaus}
              getOptionLabel={(item) => (item.code ? `${item.code} - ${item.description}` : '')}
              getOptionSelected={(option, value) => String(option.id) === String(value.id)}
              renderInput={(params) => (
                <TextField {...params} label="Mesa" margin="normal" fullWidth required />
              )}
              onChange={(e, item) => {
                handleAutocompleteChange('base_bureau_id', item);
              }}
              value={bureauSelect}
              disabled={importado}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <ImportExcel
              fileInputId="file-excel-control-muebles"
              setDataImport={setDataImport}
              btnColor="success"
              validDuplicate="MUEBLE"
              sortDuplicate="MUEBLE"
              downTemplate={{
                fileNameDown: 'Plantilla de control de muebles',
                fields: COLUMNAS_EXCEL
              }}
            />
          </span>
        ) : undefined}

        {importado && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile} — {items.length} fila(s)
          </p>
        )}

        {!importado ? (
          <>
            {esNuevo ? (
              <TextField
                key={openModalBPartner + (bPartnerSelect?.CardName || '')}
                label="Cliente"
                type="text"
                margin="normal"
                defaultValue={bPartnerSelect?.CardName || ''}
                helperText={bPartnerSelect?.Address2 || 'Elija la mesa y busque el cliente'}
                onFocus={(e) => {
                  e.preventDefault();
                  e.currentTarget.blur();
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      style={{ cursor: bureauSelect ? 'pointer' : 'not-allowed', color: '#07c107' }}
                      onClick={() => bureauSelect && setOpenModalBPartner(true)}
                      position="start"
                    >
                      <Search />
                    </InputAdornment>
                  )
                }}
                required
                fullWidth
              />
            ) : (
              <TextField
                label="Cliente"
                type="text"
                margin="normal"
                value={`${control?.customer?.CardCode || ''} - ${control?.customer?.CardName || ''}`}
                helperText={control?.address?.Address2 || ''}
                InputProps={{ readOnly: true }}
                fullWidth
              />
            )}

            {esNuevo && addresses.length > 1 ? (
              <FormControl fullWidth margin="normal">
                <InputLabel>Local</InputLabel>
                <Select
                  value={dataChanging.base_address_id || ''}
                  inputProps={{ name: 'base_address_id' }}
                  onChange={(e) => handleChange('base_address_id', e.target.value)}
                >
                  {addresses.map((item) => (
                    <MenuItem value={String(item.id)} key={item.id}>
                      {`${item.Address} - ${item.Address2}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : undefined}

            <Autocomplete
              options={furnitures}
              getOptionLabel={(item) => (item.description ? etiquetaMueble(item) : '')}
              getOptionSelected={(option, value) => String(option.id) === String(value.id)}
              renderInput={(params) => (
                <TextField {...params} label="Mueble" margin="normal" fullWidth required />
              )}
              onChange={(e, item) => {
                handleAutocompleteChange('base_furniture_id', item);
              }}
              value={furnitureSelect}
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
